import { useNavigate, useSearchParams } from "react-router-dom";
import './login.css'
import './style.css'
import { useTranslation } from 'react-i18next';
import React, { useState } from "react";
import axios from "axios";

export default function VerificationEmail() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [msg, setMsg] = useState("");
    const [searchParams] = useSearchParams();

    const email = searchParams.get("email");

    const verify = async (e) => {
        e.preventDefault();

        try {
            const res = await axios({
                method: "POST",
                url: "https://api.heryerdeingilizce.com/api/User/VerifyUser",
                data: {
                    username: email,
                    hash: document.getElementById("hash").value
                },
                headers: {
                    accept: "*/*",
                    "Content-Type": "application/json"
                }
            });

            if (res.status === 200) {
                if (res.data.success) {
                    setMsg("Doğrulandı");
                    navigate("/auth/login");
                } else {
                    setMsg(res.data.message);
                }
            } else {
                setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
            }
        } catch (err) {
            setMsg(err?.response?.data?.message || err.message);
        }
    };

    return (
        <div className="container-fluid h-custom">
            <div className="row d-flex justify-content-center align-items-center">
                <div className="col-md-9 col-lg-6 col-xl-5">
                    <img
                        src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
                        className="img-fluid"
                        alt="Sample"
                    />
                </div>

                <div className="col-md-8 col-lg-6 col-xl-4 offset-xl-1" id="registerForm">
                    <form onSubmit={verify}>
                        <div className="divider d-flex align-items-center my-4">
                            <h2 className="text-center fw-bold mx-3 mb-0">
                                {t("verifyEmail")}
                            </h2>
                        </div>

                        <h3>{msg}</h3>
                        <br />

                        <div className="form-outline mb-3">
                            <label className="form-label" htmlFor="hash">
                                {t("verifyHash")}
                            </label>
                            <textarea
                                id="hash"
                                name="hash"
                                className="form-control form-control-lg"
                                placeholder={t("verifyHash")}
                                required
                            />
                        </div>

                        <div className="text-center">
                            <button
                                type="submit"
                                className="btn btn-success btn-lg"
                                style={{ paddingLeft: "2.5rem", paddingRight: "2.5rem" }}
                            >
                                {t("verify")}
                            </button>
                        </div>
                    </form>

                    <br /><br />
                </div>
            </div>
        </div>
    );
}